import type { VNode } from 'preact';

export interface PermissionDeniedOverlayProps {
  errorMessage: string;
  visible?: boolean;
  onClose?: () => void;
}

export function PermissionDeniedOverlay({
  errorMessage,
  visible = true,
  onClose,
}: PermissionDeniedOverlayProps): VNode {
  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }
    window.location.reload();
  };

  if (!visible || !errorMessage) {
    return <div style={{ display: 'none' }} />;
  }

  const [errorPrimary, errorSecondary] = errorMessage.split(/<br\s*\/?>\s*<br\s*\/?>/i);
  const hasErrorSecondary = Boolean(errorSecondary && errorSecondary.trim().length > 0);

  return (
    <div
      className="fixed inset-0 z-[1000] flex flex-col justify-end px-5"
      style={{
        background: 'var(--brand-bg-deep)',
        color: 'var(--brand-text)',
      }}
    >
      <div className="w-full pb-[72px]">
        <div className="mx-auto flex w-full max-w-[420px] flex-col items-center text-center text-[20px] font-light">
          <div
            className="font-medium"
            dangerouslySetInnerHTML={{ __html: errorPrimary || errorMessage }}
          />
          {hasErrorSecondary && (
            <div className="my-8 h-px w-[40px]" style={{ background: 'rgba(245, 238, 248, 0.4)' }} />
          )}
          {hasErrorSecondary && (
            <div
              className="text-[18px] font-light"
              dangerouslySetInnerHTML={{ __html: errorSecondary }}
            />
          )}
        </div>

        <div className="mx-auto mt-[78px] w-full max-w-[260px]">
          <button
            onClick={handleClose}
            className="h-12 w-full rounded-full bg-transparent transition-colors"
            style={{
              border: '2px solid var(--brand-text)',
              color: 'var(--brand-text)',
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
